var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hideCarousel
        ? _c("div", {
            staticClass: "image-cover",
            style: _vm.bgImageStyle,
            on: {
              click: function($event) {
                _vm.hideCarousel = false
              }
            }
          })
        : _c("vcarousel", {
            style: "max-height: " + _vm.height + "; overflow: hidden",
            attrs: {
              data: _vm.data,
              indicators: _vm.showIndicators && this.images.length > 1,
              autoplay: _vm.autoplay,
              "indicator-type": "disc"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d037be6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d037be6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/SmallCarousel.vue
// module id = null
// module chunks = 